import { z } from "zod";
import { USER_ROLES } from "./enums";

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const currentUserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  fullName: z.string(),
  role: z.enum(USER_ROLES),
  telegramLinked: z.boolean(),
});
export type CurrentUser = z.infer<typeof currentUserSchema>;
